(function () {
  const drawer = document.querySelector('[data-buscador-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('[data-buscador-panel]');
  const input = drawer.querySelector('[data-buscador-input]');
  const formulario = drawer.querySelector('[data-buscador-formulario]');
  const limpiar = drawer.querySelector('[data-buscador-limpiar]');
  const vacio = drawer.querySelector('[data-buscador-vacio]');
  const resultados = drawer.querySelector('[data-buscador-resultados]');
  const carga = drawer.querySelector('[data-buscador-carga]');
  const sinResultados = drawer.querySelector('[data-buscador-sin-resultados]');
  const verTodo = drawer.querySelector('[data-buscador-ver-todo]');
  const live = drawer.querySelector('[data-buscador-live]');

  const debounceMs = Number(drawer.dataset.debounce || 300);
  const limiteProductos = Number(drawer.dataset.limiteProductos || 8);
  const limiteSugerencias = Number(drawer.dataset.limiteSugerencias || 5);
  const urlSuggest = drawer.dataset.urlSuggest;
  const urlBusqueda = drawer.dataset.urlBusqueda;
  const textoSinImagen = drawer.dataset.textoSinImagen || '';

  const tituloSugerencias = drawer.dataset.tituloSugerencias || '';
  const tituloProductos = drawer.dataset.tituloProductos || '';
  const textoResultados = drawer.dataset.textoResultados || '';
  const textoLiveSinResultados = drawer.dataset.textoLiveSinResultados || '';
  const productosNoDisponibles = drawer.dataset.productosNoDisponibles || 'show';

  let temporizador = null;
  let controlador = null;
  let focoAnterior = null;

  const selectoresFoco =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function atraparFoco(contenedor) {
    if (window.NaiaUI) {
      window.NaiaUI.atraparFoco(contenedor);
      return;
    }
    const elementos = Array.from(contenedor.querySelectorAll(selectoresFoco)).filter(
      (el) => !el.closest('[hidden]')
    );
    if (!elementos.length) return;
    const primero = elementos[0];
    const ultimo = elementos[elementos.length - 1];
    primero.focus();
    contenedor.addEventListener(
      'keydown',
      function manejarTab(evento) {
        if (evento.key !== 'Tab') return;
        if (evento.shiftKey && document.activeElement === primero) {
          evento.preventDefault();
          ultimo.focus();
        } else if (!evento.shiftKey && document.activeElement === ultimo) {
          evento.preventDefault();
          primero.focus();
        }
      },
      { once: false }
    );
  }

  function abrirDrawer() {
    focoAnterior = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      drawer.setAttribute('data-abierto', '');
      if (window.NaiaUI) window.NaiaUI.bloquearScroll(drawer);
      else document.body.style.overflow = 'hidden';
      input.focus();
      atraparFoco(panel);
    });
  }

  function cerrarDrawer() {
    drawer.removeAttribute('data-abierto');
    drawer.setAttribute('aria-hidden', 'true');
    if (window.NaiaUI) {
      window.NaiaUI.desbloquearScroll(drawer);
      window.NaiaUI.liberarFoco(panel);
    } else document.body.style.overflow = '';
    resetearBusqueda();
    window.setTimeout(() => {
      drawer.hidden = true;
    }, 300);
    if (focoAnterior) focoAnterior.focus();
  }

  function resetearBusqueda() {
    input.value = '';
    input.setAttribute('aria-expanded', 'false');
    limpiar.hidden = true;
    vacio.hidden = false;
    resultados.hidden = true;
    resultados.innerHTML = '';
    sinResultados.hidden = true;
    verTodo.hidden = true;
    carga.hidden = true;
    if (controlador) controlador.abort();
  }

  function mostrarCarga(visible) {
    carga.hidden = !visible;
  }

  function construirUrlSuggest(termino) {
    const url = new URL(urlSuggest, window.location.origin);
    url.searchParams.set('q', termino);
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.append('resources[type]', 'product');
    url.searchParams.append('resources[limit]', String(limiteProductos));
    url.searchParams.append('resources[type]', 'query');
    url.searchParams.append('resources[limit]', String(limiteSugerencias));
    url.searchParams.set('resources[options][unavailable_products]', productosNoDisponibles);
    return url.toString();
  }

  function renderizarResultados(data, termino) {
    const productos = data?.resources?.results?.products || [];
    const sugerencias = data?.resources?.results?.queries || [];
    resultados.innerHTML = '';

    if (!productos.length && !sugerencias.length) {
      vacio.hidden = true;
      resultados.hidden = true;
      sinResultados.hidden = false;
      verTodo.hidden = false;
      verTodo.href = `${urlBusqueda}?q=${encodeURIComponent(termino)}&type=product`;
      live.textContent = textoLiveSinResultados;
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    sinResultados.hidden = true;
    vacio.hidden = true;
    resultados.hidden = false;
    input.setAttribute('aria-expanded', 'true');

    if (sugerencias.length) {
      const seccion = document.createElement('section');
      seccion.className = 'buscador-drawer__resultados-seccion';
      seccion.innerHTML = `<h3 class="buscador-drawer__resultados-titulo">${tituloSugerencias}</h3>`;
      const lista = document.createElement('ul');
      lista.className = 'buscador-drawer__sugerencias';
      sugerencias.forEach((item) => {
        const li = document.createElement('li');
        const enlace = document.createElement('a');
        enlace.className = 'buscador-drawer__sugerencia';
        enlace.href = item.url;
        enlace.setAttribute('role', 'option');
        enlace.textContent = item.text;
        li.appendChild(enlace);
        lista.appendChild(li);
      });
      seccion.appendChild(lista);
      resultados.appendChild(seccion);
    }

    if (productos.length) {
      const seccion = document.createElement('section');
      seccion.className = 'buscador-drawer__resultados-seccion';
      seccion.innerHTML = `<h3 class="buscador-drawer__resultados-titulo">${tituloProductos}</h3>`;
      const lista = document.createElement('ul');
      lista.className = 'buscador-drawer__resultados-grid';

      productos.forEach((producto) => {
        const li = document.createElement('li');
        li.className = 'buscador-drawer__resultado';
        li.setAttribute('role', 'option');

        const enlace = document.createElement('a');
        enlace.className = 'buscador-drawer__resultado-enlace';
        enlace.href = producto.url;

        if (producto.featured_image?.url || producto.image) {
          const img = document.createElement('img');
          img.className = 'buscador-drawer__resultado-imagen';
          img.src = producto.featured_image?.url || producto.image;
          img.alt = producto.title || '';
          img.loading = 'lazy';
          enlace.appendChild(img);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'buscador-drawer__resultado-sin-imagen';
          placeholder.textContent = textoSinImagen;
          enlace.appendChild(placeholder);
        }

        const titulo = document.createElement('span');
        titulo.className = 'buscador-drawer__resultado-titulo';
        titulo.textContent = producto.title;

        const precio = document.createElement('span');
        precio.className = 'buscador-drawer__resultado-precio';
        precio.textContent = producto.price || '';

        enlace.appendChild(titulo);
        enlace.appendChild(precio);
        li.appendChild(enlace);
        lista.appendChild(li);
      });

      seccion.appendChild(lista);
      resultados.appendChild(seccion);
    }

    verTodo.hidden = false;
    verTodo.href = `${urlBusqueda}?q=${encodeURIComponent(termino)}&type=product`;
    live.textContent = textoResultados.replace('[[count]]', String(productos.length));
  }

  function buscar(termino) {
    if (controlador) controlador.abort();
    controlador = new AbortController();
    mostrarCarga(true);

    fetch(construirUrlSuggest(termino), {
      signal: controlador.signal,
      headers: { Accept: 'application/json' },
    })
      .then((respuesta) => respuesta.json())
      .then((data) => {
        mostrarCarga(false);
        renderizarResultados(data, termino);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        mostrarCarga(false);
        sinResultados.hidden = false;
        vacio.hidden = true;
        resultados.hidden = true;
      });
  }

  function manejarEntrada() {
    const termino = input.value.trim();
    limpiar.hidden = termino.length === 0;

    if (!termino.length) {
      if (controlador) controlador.abort();
      mostrarCarga(false);
      resultados.hidden = true;
      resultados.innerHTML = '';
      sinResultados.hidden = true;
      verTodo.hidden = true;
      vacio.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    window.clearTimeout(temporizador);
    temporizador = window.setTimeout(() => buscar(termino), debounceMs);
  }

  document.addEventListener('cabecera:abrir-buscador', abrirDrawer);

  document.querySelectorAll('[data-abrir-buscador]').forEach((boton) => {
    boton.addEventListener('click', abrirDrawer);
  });

  drawer.querySelectorAll('[data-buscador-cerrar]').forEach((boton) => {
    boton.addEventListener('click', cerrarDrawer);
  });

  limpiar.addEventListener('click', () => {
    resetearBusqueda();
    input.focus();
  });

  input.addEventListener('input', manejarEntrada);

  formulario.addEventListener('submit', (evento) => {
    const termino = input.value.trim();
    if (!termino.length) {
      evento.preventDefault();
    }
  });

  document.addEventListener('keydown', (evento) => {
    if (evento.key === 'Escape' && drawer.hasAttribute('data-abierto')) {
      cerrarDrawer();
    }
  });
})();
